// DronesPage.js
import { useState, useEffect } from "react";
import DroneViewer from "./DroneViewer";
import DronesPermissionsManager from "./DronesPermissionsManager"; // importamos
import { API_URL } from "../../config";
import { authFetch } from "../../utils";

export default function DronesPage({ can }) {
  const [selectedDrone, setSelectedDrone] = useState("");
  const [mode, setMode] = useState("view");
  const [showDialog, setShowDialog] = useState(false);
  const [drones, setDrones] = useState([]);

  const [streamToken, setStreamToken] = useState(null);
  const [loadingToken, setLoadingToken] = useState(false);
  const [tokenError, setTokenError] = useState(null);


  const baseUrl = "https://dronavispat.senticnel.com:8889";


  useEffect(() => {
    setShowDialog(true);    
  }, []);

  useEffect(() => {
    // Cargar lista de drones desde el backend
    const fetchDrones = async () => {
      try {
        const resp = await authFetch(`${API_URL}drones`);
        if (!resp.ok) throw new Error("Error al cargar drones");
        const data = await resp.json();
        setDrones(data);
        if (data.length > 0) {
          setSelectedDrone(data[0].droneId); 
        }
      } catch (err) {
        console.error("Error cargando drones:", err);
      }
    };
    fetchDrones();
  }, []);

  useEffect(() => {
    if (!selectedDrone || mode !== "view") return;

    const fetchStreamToken = async () => {
      try {
        setLoadingToken(true);
        setTokenError(null);
        setStreamToken(null);


        const resp = await authFetch(
          `${API_URL}drones/view-stream-token/${selectedDrone}`,
          {
            method: "POST"
          }
        );

        if (!resp.ok) {
          if (resp.status === 403) {
            throw new Error("No tiene permisos para ver este dron");
          }
          throw new Error("Error obteniendo token de streaming");
        }

        const data = await resp.json();
        setStreamToken(data.streamToken);
      } catch (err) {
        console.error(err);
        setTokenError(err.message);
      } finally {
        setLoadingToken(false);
      }
    };

    fetchStreamToken();
  }, [selectedDrone, mode]);


  const handleAccept = () => {
    setShowDialog(false);
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      {showDialog && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "2rem",
              borderRadius: "8px",
              maxWidth: "500px",
              textAlign: "center"
            }}
          >
            <p>
              ATENCIÓN: Al acceder a esta sección el usuario se compromete a no distribuir el contenido de las imágenes mostradas en esta plataforma.
              En caso de incumplimiento, el usuario será responsable de las consecuencias legales derivadas de dicha acción.
            </p>
            <button onClick={handleAccept} style={{ marginTop: "1rem" }}>
              Aceptar
            </button>
          </div>
        </div>
      )}

      {!showDialog && (
        <>
          <header
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "1rem",
              background: "#eee"
            }}
          >
            <div>
              <label>
                Selecciona dron:{" "}
                <select
                  value={selectedDrone}
                  onChange={(e) => setSelectedDrone(e.target.value)}
                >
                  {drones.map((drone) => (
                    <option key={drone.droneId} value={drone.droneId}>
                      {drone.name}
                    </option>
                  ))}
                </select>
              </label>
            </div>
            {can(['drone-manager','admin']) && (
            <button onClick={() => setMode(mode === "view" ? "manage" : "view")}>
              {mode === "view" ? "Gestión usuarios drones" : "← Volver a visualización"}
            </button>
            )}
          </header>

          <main style={{ height: mode === 'view' ? "calc(100% - 60px)" : "auto", overflow: mode === 'view' ? "auto" : "visible" }}>
            {mode === "view" ? (
              selectedDrone ? (
                loadingToken ? (
                  <p style={{ padding: "2rem" }}>Obteniendo acceso al streaming…</p>
                ) : tokenError ? (
                  <p style={{ padding: "2rem", color: "red" }}>{tokenError}</p>
                ) : streamToken ? (
                  <DroneViewer
                    whepUrl={`${baseUrl}/${selectedDrone}/whep`}
                    streamToken={streamToken}
                  />
                ) : null
              ) : (
                <p style={{ padding: "2rem" }}>No hay drones disponibles</p>
              )
            ) : (
              <div style={{ padding: "2rem" }}>
                {selectedDrone ? (
                  <DronesPermissionsManager
                    drone={drones.find(d => d.droneId === selectedDrone)}
                    can={can}
                  />
                ) : (
                  <p>No hay dron seleccionado</p>
                )}
              </div>
            )}
          </main>

        </>
      )}
    </div>
  );
}
